export default __webpack_public_path__ + "assets/blank-profile.0334f4b4.png";